/**
 * 작성자 : 한영광
 * 날짜 : 2023.06.22
 * 경로 : 근로자 관리 - 근로자 특수건강검진 관리
 */
import { useEffect, useState, useRef, RefObject } from 'react';
import { toast } from 'react-toastify';
import { PulseLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { IUser, pageInfoState, userState } from '../../atoms';
import { BtnGhost } from '../../components/Button';
import { INIT_WORKER_STATUS, LIST_COUNT, WORK_STATUS_SEARCH } from '../../_constants';
import { SearchOptions } from '../../assets/styles/SearchOptions';
import { scrollToNodeTop } from '../../utils/scrollToNodeTop';
import { useDetectScrolledToBottom } from '../../utils/useDetectScrolledToBottom';
import { IoChevronUpSharp } from 'react-icons/io5';
import { FloatingButtonToTop } from '../../assets/styles/FloatingButtonToTop';
import Input from '../../components/Input';
import { IComCdList, ITabObject } from 'customTypes';
import { setComCdListState } from '../../utils/setComCdListState';
import { today, todayYYYYMMDD } from '../../utils/formatDate';
import { useReactToPrint } from 'react-to-print';
import Portal from '../../components/Portal';
import InfoWorkerModal from '../../components/Modal/InfoWorkerModal';
import RangePicker, { onChangeRangeInput } from '../../components/RangePicker';
import Tab from '../../components/Tab';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import useOnKeydownF9 from '../../utils/useOnKeydownF9';
import { logPost } from '../../services/log';
import SearchSelectBoxSm from '../../components/SearchSelectBoxSm';
import { useSetAuth } from '../../utils/useSetAuth';
import { trimObject } from '../../utils/trimObject';
import TuiGrid from '../../components/Table/TuiGrid';
import SelectBox from '../../components/SelectBox';
import { useSetSjcd } from '../../utils/useSetSjcd';
import useSetJobtype from '../../utils/useSetJobtype';
import { LoadingModalBackground } from '../../assets/styles/Modal';
import i18n from '../../translation/i18n';
import TuiGridWrapper from '../../components/Table/TuiGridWrapper';
import { useGetFrozenCount } from '../../utils/getFrozenCount';
import { ContentsContainerRoot } from '../../assets/styles/ContentsContainerRoot';
import useSetListCount from '../../utils/useSetListCount';
import { apiGet } from '../../services/_common';
import ShortcutButton from '../../components/button/ShortcutButton';
import useTuiGridSize from '../../hooks/useTuiGridSize';
import SearchFilterModal from '../../components/Modal/SearchFilterModal';
import { showExcelButton } from '../../utils/deviceAuth';

const Root = styled(ContentsContainerRoot)``;

const Sworker10 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const INIT_WHS_RESULT = { type: 'wHsresult', wHsresult: 'A', cdName: t('검진 결과 전체') };
  const { siteJoinInfoList } = useSetSjcd();
  const { auth } = useSetAuth(); // 사용자 권한값 훅
  const { isF9Pressed, setIsF9Pressed } = useOnKeydownF9(); // f9키 프레스 훅
  const { listCount, setListCount, patchUserMenuAPI } = useSetListCount(); // 검색줄수설정 훅
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const toDay = todayYYYYMMDD();
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList, eExcelYn, eListYn } = userInfo;
  const [tableState, setTableState] = useState<any[]>([]);
  const [orgTableState, setOrgTableState] = useState<any[]>([]);
  const [columns, setColumns] = useState<any[]>([]);
  const wNameRef = useRef<HTMLInputElement>(null);
  const bigoRef = useRef<HTMLInputElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const [visibleRangePicker, setVisibleRangePicker] = useState(false);
  const [rangeState, setRangeState] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
  const [listCountComCdList, setListCountComCdList] = useState<IComCdList[]>([]); // 검색줄수 공통코드
  const [jikJongList, setJikJongList] = useState<any[]>([]);
  const [healthSetList, setHealthSetList] = useState<any[]>([]);
  const [searchOption, setSearchOption] = useState({ wName: '', start: toDay, end: toDay, wHsbigo: '' });
  const [wWorkstatus, setWWorkstatus] = useState(INIT_WORKER_STATUS);
  const [sjCd, setSjCd] = useState({ type: 'sjCd', sjCd: '', cdName: '' });
  const [wHsresult, setWHsresult] = useState(INIT_WHS_RESULT);
  const [wPrejobtype, setWPrejobtype] = useState({ type: 'wPrejobtype', wPrejobtype: '', cdName: '' });
  const [wJobtype, setWJobtype] = useState({ type: 'wJobtype', wJobtype: '', cdName: '' });
  const { prejobtypeList, jobtypeList } = useSetJobtype(wPrejobtype.wPrejobtype);
  const [excelBtn, setExcelBtn] = useState(false);
  const { isBottom } = useDetectScrolledToBottom(tableRef);
  const [initiate, setinitiate] = useState('');
  const [openModal, setOpenModal] = useState<any>({ status: false, type: '', code: '', index: 0 });
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const [rowKey, setRowKey] = useState('');
  const [filterTableState, setFilterTableState] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  const { tuiHeight } = useTuiGridSize(componentRef);
  const frozenCount = useGetFrozenCount();
  const showExcelBtn = showExcelButton(auth.excelAuth);

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  useEffect(() => {
    setLoading(true);
    getWorkerAPI().then((res: any) => {
      if (res.status === 200) {
        getHealthBoxAPI();
        setComCdListState(LIST_COUNT, setListCountComCdList, false);
        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '근로자 특수 건강검진 관리',
          action: '조회',
          etc: ``,
        });
        setLoading(false);
      }
    });
  }, []);

  useEffect(() => {
    setColumns(
      userInfo.prejobtypeYn === 'Y'
        ? [
            {
              header: t('근로자명'),
              name: 'wName',
              sortable: true,
              isPrivate: true,
              maskingType: 'name',
              width: 150,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('협력업체'),
              name: 'sjName',
              sortable: true,
              filter: 'select',
              width: 200,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('공종'),
              name: 'wPrejobtypeName',
              sortable: true,
              filter: 'select',
              minWidth: 120,
            },
            {
              header: t('직종'),
              name: 'wJobtypeName',
              sortable: true,
              filter: 'select',
              minWidth: 120,
            },
            {
              header: t('특수 검진일자'),
              name: 'wHsdate',
              align: 'center',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('특수 검진결과'),
              name: 'wHsresult',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('비고'),
              name: 'wHsbigo',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('최종 출역일자'),
              name: 'inoutDate',
              align: 'center',
              sortable: true,
              minWidth: 160,
            },
            {
              header: t('취업일자'),
              name: 'wJobdate',
              align: 'center',
              sortable: true,
              minWidth: 120,
            },
            {
              header: t('근로 상태'),
              name: 'wWorkstatusName',
              align: 'center',
              sortable: true,
              filter: 'select',
              minWidth: 120,
            },
          ]
        : [
            {
              header: t('근로자명'),
              name: 'wName',
              sortable: true,
              isPrivate: true,
              maskingType: 'name',
              width: 150,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('협력업체'),
              name: 'sjName',
              sortable: true,
              filter: 'select',
              width: 200,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('직종'),
              name: 'wJobtypeName',
              align: 'center',
              sortable: true,
              filter: 'select',
              minWidth: 120,
            },
            {
              header: t('특수 검진일자'),
              name: 'wHsdate',
              align: 'center',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('특수 검진결과'),
              name: 'wHsresult',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('비고'),
              name: 'wHsbigo',
              sortable: true,
              minWidth: 120,
              renderer: { classNames: ['text_secondary'] },
            },
            {
              header: t('최종 출역일자'),
              name: 'inoutDate',
              align: 'center',
              sortable: true,
              minWidth: 160,
            },
            {
              header: t('취업일자'),
              name: 'wJobdate',
              align: 'center',
              sortable: true,
              minWidth: 120,
            },
            {
              header: t('근로 상태'),
              name: 'wWorkstatusName',
              align: 'center',
              sortable: true,
              filter: 'select',
              minWidth: 120,
            },
          ]
    );
  }, [i18n.language]);

  useEffect(() => {
    if (isF9Pressed) {
      onClickSearch();
      setIsF9Pressed(false);
    }
  }, [isF9Pressed]);

  useEffect(() => {
    if (!rangeState[0].startDate) {
      return;
    }
    setSearchOption((prev) => ({ ...prev, start: dayjs(rangeState[0].startDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].startDate]);

  useEffect(() => {
    if (!rangeState[0].endDate) {
      return;
    }
    setSearchOption((prev) => ({ ...prev, end: dayjs(rangeState[0].endDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].endDate]);

  useEffect(() => {
    setWJobtype({ type: 'wJobtype', wJobtype: '', cdName: '' });
    if (wPrejobtype.wPrejobtype === '') setJikJongList([]);
  }, [wPrejobtype.wPrejobtype]);

  useEffect(() => {
    setJikJongList(jobtypeList);
  }, [jobtypeList]);

  useEffect(() => {
    setTableState(
      orgTableState.map((v: any) => {
        return { ...v, wWorkstatusName: t(v.wWorkstatusName) };
      })
    );
  }, [i18n.language]);

  // 근로자 정보 리스트 조회 API
  const getWorkerAPI = async () => {
    const newSearchOption = {
      ...searchOption,
      wWorkstatus: wWorkstatus.wWorkstatus === 'A' ? '' : wWorkstatus.wWorkstatus,
      sjCd: sjCd.sjCd,
      wHsresult: wHsresult.wHsresult === 'A' ? '' : wHsresult.wHsresult,
      wHsdate1: searchOption.start.replaceAll('-', ''),
      wHsdate2: searchOption.end.replaceAll('-', ''),
      wPrejobtype: wPrejobtype.wPrejobtype,
      wJobtype: wJobtype.wJobtype,
    };
    const { start, end, ...finalSearchObj } = newSearchOption; // searchOption에서 start, end값 삭제
    const trimData = trimObject(finalSearchObj);
    const req = { ...trimData, hCd: userInfo.hCd, sCd: userInfo.sCd };
    const res = await apiGet({ path: '/worker/hspecial', req });
    const { data, statusCode } = res.data;
    if (statusCode === 200) {
      setLoading(false);

      await getHealthBoxAPI().then(({ msg, data: _data }) => {
        if (msg === 'success') {
          const newList = data.workerList.map((el: any) => {
            const findwHsresult = _data.find((el2: any) => el2.wHsresult === el.wHsresult);
            if (findwHsresult) return { ...el, wHsresult: findwHsresult.cdName };
            return el;
          });
          setOrgTableState(newList.filter((v: any) => v.wHndate !== null));
          setTableState(
            newList
              .filter((v: any) => v.wHndate !== null)
              .map((v: any) => {
                return { ...v, wWorkstatusName: t(v.wWorkstatusName) };
              })
          );
        }
      });
    } else {
      setLoading(false);
      // toast.error(t(ERROR));
    }
    return res;
  };

  // 특수 검진결과 리스트 조회 API
  const getHealthBoxAPI = async () => {
    const req = { hCd: userInfo.hCd, sCd: userInfo.sCd, hcpCodeOne: 'S' };
    const res = await apiGet({ path: '/setting/health/box', req });
    const { data, statusCode } = res.data;
    if (statusCode === 200) {
      const newList: any[] = [];
      newList.push(INIT_WHS_RESULT);
      data.healthSet.map((v: any) => {
        newList.push({
          type: 'wHsresult',
          wHsresult: v.hcpCode,
          cdName: v.hcpName,
        });
      });
      setHealthSetList(newList);
      return { msg: 'success', data: newList };
    }
    // toast.error(t(ERROR));
    return { msg: 'error', data: res };
  };

  // 검색 버튼 클릭
  const onClickSearch = (filterRef?: RefObject<HTMLDivElement>) => {
    setRowKey('');
    if (!openModal.status || (openModal.status && openModal.type === 'filter')) {
      if (searchOption.end && searchOption.start > searchOption.end) {
        toast.warning(t('날짜를 다시 입력하세요'));
        setSearchOption((prev: any) => ({ ...prev, end: '' }));
      } else {
        setLoading(true);
        if (filterRef) {
          // 모바일일 경우 검색 필터 모달 창 닫기
          filterRef.current?.classList.remove('active');
          setOpenModal({ status: false, type: 'filter' });
        }
        setVisibleRangePicker(false);
        navigate({
          pathname: location.pathname,
          search: '',
        });
        getWorkerAPI();
      }
    }
  };

  const initiateSearchOptions = () => {
    setWWorkstatus(INIT_WORKER_STATUS);
    setSjCd({ type: 'sjCd', sjCd: '', cdName: '' });
    setWHsresult(INIT_WHS_RESULT);
    setWPrejobtype({ type: 'wPrejobtype', wPrejobtype: '', cdName: '' });
    setWJobtype({ type: 'wJobtype', wJobtype: '', cdName: '' });
  };

  // 초기화 버튼 클릭
  const onClickInitiateSearchOption = () => {
    Object.keys(searchOption).map((el: any) => {
      return setSearchOption((prev) => ({ ...prev, [el]: '', start: '', end: '' }));
    });
    setinitiate(`${Math.random()}`);
    initiateSearchOptions();
    setRangeState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    ]);
  };

  // 엑셀 저장 버튼 클릭
  const onClickExcelSave = () => {
    if (tableState.length <= 0) return;
    setExcelBtn(true);
    logPost({
      hCd: userInfo.hCd,
      sCd: userInfo.sCd,
      userId: userInfo.userId,
      menu: '근로자 특수 건강검진 관리',
      action: '엑셀 저장',
      etc: ``,
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  // 인쇄 버튼 클릭
  const onClickPrint = () => {
    handlePrint();
  };
  // 근로자 Row 클릭
  const onClickRow = (rowData: any, columnName: any, filteredIndex: number) => {
    setRowKey(`${filteredIndex}`);
    setOpenModal({ status: true, type: 'infoWorker', code: rowData.wCd, index: filteredIndex });
  };

  const renderExcelBtn = () => {
    if (showExcelBtn) {
      return (
        <BtnGhost onClick={onClickExcelSave}>
          <span className='icon-ms-xlsx'>X</span> {t('엑셀')}
        </BtnGhost>
      );
    }
    return null;
  };

  const renderPrintBtn = () => {
    if (auth.printAuth) {
      return (
        <BtnGhost onClick={onClickPrint}>
          <span className='material-symbols-rounded'>print</span>
          {t('인쇄')}
        </BtnGhost>
      );
    }
    return null;
  };

  const onClickRangeInput = () => {
    if (!visibleRangePicker) setVisibleRangePicker(true);
  };

  const onClickTab = (tab: string) => {
    setCurrentTabMrCd(tab);
  };

  // 근로자명 입력창에서 엔터입력시 검색
  const onEnterKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (wNameRef.current) onClickSearch();
      if (bigoRef.current) onClickSearch();
    }
  };

  // 필터 버튼 클릭
  const onClickFilter = () => {
    setOpenModal({ status: true, type: 'filter' });
  };

  return (
    <div className='contents'>
      <div className='content-container oneColumn'>
        <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
        <Root loading={loading}>
          <SearchOptions>
            {size.innerSize.W > 1024 ? (
              <>
                {isBottom && (
                  <FloatingButtonToTop>
                    <button type='button' onClick={() => scrollToNodeTop(tableRef)}>
                      <IoChevronUpSharp size={20} style={{ stroke: 'white' }} />
                    </button>
                  </FloatingButtonToTop>
                )}
                <div className='inputsWrapper'>
                  <div className='inputForm-col withLabelComCf'>
                    <label htmlFor='wWorkstatus'>{t('근로 상태')}</label>
                    <SelectBox
                      options={WORK_STATUS_SEARCH}
                      defaultOption={t('재직')}
                      state={wWorkstatus}
                      setState={setWWorkstatus}
                      stateKey='wWorkstatus'
                      initiateKey={wWorkstatus.wWorkstatus}
                      filterbar='filter-1-left'
                    />
                  </div>
                  <div className='inputForm-row withLabel'>
                    <label htmlFor='sjCd'>{t('협력업체')}</label>
                    <div className='inputForm-col'>
                      <SearchSelectBoxSm
                        options={siteJoinInfoList}
                        defaultOption={t('전체')}
                        state={sjCd}
                        setState={setSjCd}
                        stateKey='sjCd'
                        codeKey='cdName'
                        initiateKey={initiate}
                        filterbar='filter-1-left'
                        optionHeight='height-md'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row-fit'>
                    <span className='calendarLabel'>{t('검진 일자')}</span>
                    <div className='inputForm-col'>
                      <div className='flex-basic'>
                        <input id='startInput' type='text' value={searchOption.start} onChange={(e) => onChangeRangeInput(e, 'start', setRangeState, setSearchOption)} />
                        <span className='inputDash'> ~ </span>
                        <input id='endInput' type='text' value={searchOption.end} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setSearchOption)} />
                      </div>
                      {visibleRangePicker && (
                        <div className='rangePickerWrapper'>
                          <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} />
                        </div>
                      )}
                    </div>
                    <button type='button' className='date-picker-btn' onClick={onClickRangeInput}>
                      <span className='material-symbols-rounded'>calendar_month</span>
                    </button>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col'>
                      <SelectBox
                        options={healthSetList}
                        defaultOption={t('검진 결과 전체')}
                        state={wHsresult}
                        setState={setWHsresult}
                        stateKey='wHsresult'
                        initiateKey={wHsresult.wHsresult}
                        filterbar='filter-1-center'
                        optionHeight='height-md'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col'>
                      <Input placeholder='비고' label='' type='text' id='wHnbigo' name='wHsbigo' state={searchOption} setState={setSearchOption} inputRef={bigoRef} onKeyDown={onEnterKeyDown} />
                    </div>
                  </div>
                  {userInfo.prejobtypeYn === 'Y' && (
                    <div className='inputForm-row'>
                      <div className='inputForm-col'>
                        <SearchSelectBoxSm
                          options={prejobtypeList}
                          defaultOption={t('공종 전체')}
                          state={wPrejobtype}
                          setState={setWPrejobtype}
                          stateKey='wPrejobtype'
                          codeKey='cdName'
                          initiateKey={initiate}
                          filterbar='filter-1-right'
                          comboWidth='expand-box-sm'
                          optionHeight='height-md'
                        />
                      </div>
                    </div>
                  )}
                  <div className='inputForm-row'>
                    <div className='inputForm-col'>
                      <SearchSelectBoxSm
                        options={jikJongList}
                        defaultOption={t('직종 전체')}
                        state={wJobtype}
                        setState={setWJobtype}
                        stateKey='wJobtype'
                        codeKey='cdName'
                        initiateKey={wJobtype.wJobtype}
                        filterbar='filter-1-right'
                        comboWidth='expand-box-sm'
                        optionHeight='height-md'
                      />
                    </div>
                  </div>
                  <div className='inputForm-row'>
                    <div className='inputForm-col'>
                      <Input placeholder={t('근로자명')} label='' type='text' id='wName' name='wName' state={searchOption} setState={setSearchOption} inputRef={wNameRef} onKeyDown={onEnterKeyDown} />
                    </div>
                  </div>
                </div>
                <div className='inputsWrapper'>
                  <div className='secondSearchOption'>
                    <div className='flex-basic textBtnGroup'>
                      <ShortcutButton icon='search' buttonText='검색' shortcut='F9' onClick={onClickSearch} />
                      <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
                      <div className='searchResult'>
                        {t('총')}
                        <span>{tableState.length}</span>
                        {t('개')}
                      </div>
                      <div className='inputForm-row'>
                        <div className='inputForm-col withLabelComCf'>
                          <label htmlFor='useYn'>{t('보기 설정')}</label>
                          <SelectBox
                            options={listCountComCdList}
                            defaultOption={listCount[LIST_COUNT]}
                            state={listCount}
                            setState={setListCount}
                            stateKey={LIST_COUNT}
                            initiateKey={listCount[LIST_COUNT]}
                            setTableLinesAPI={patchUserMenuAPI}
                            optionHeight='height-sm'
                            rsearch
                          />
                        </div>
                      </div>
                    </div>
                    <div className='flex-basic iconBtnGroup'>
                      {renderExcelBtn()}
                      {/* {renderPrintBtn()} */}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='filter-wrapper'>
                <div className='inputsWrapper'>
                  <div className='inputForm-row' style={{ width: 'calc(100% - 3.5rem)' }}>
                    <div className='inputForm-col'>
                      <Input
                        placeholder={t('근로자명')}
                        label=''
                        type='text'
                        id='wName'
                        name='wName'
                        state={searchOption}
                        setState={setSearchOption}
                        inputRef={wNameRef}
                        onKeyDown={onEnterKeyDown}
                        ico='search'
                      />
                    </div>
                  </div>
                  <BtnGhost onClick={onClickFilter} className='filter-btn'>
                    <span className='material-symbols-rounded'>filter_alt</span>
                  </BtnGhost>
                </div>
                <div className='inputsWrapper'>
                  <div className='flex-basic iconBtnGroup'>{renderExcelBtn()}</div>
                </div>
              </div>
            )}
          </SearchOptions>
          <TuiGridWrapper componentRef={componentRef}>
            <TuiGrid
              data={tableState}
              filterTableState={filterTableState}
              setFilterTableState={setFilterTableState}
              columns={columns}
              perPage={Number(listCount[LIST_COUNT])}
              excelBtn={excelBtn}
              setExcelBtn={setExcelBtn}
              usePagenation
              onClickRow={onClickRow}
              scrollX
              height={tuiHeight}
              eListYn={eListYn}
              eExcelYn={eExcelYn}
              rowKey={rowKey}
              frozenCount={frozenCount}
              setRowKey={setRowKey}
            />
          </TuiGridWrapper>
        </Root>
      </div>
      {loading && (
        <LoadingModalBackground>
          <PulseLoader className='flex-center' color='rgb(0, 122, 255)' size='1rem' />
        </LoadingModalBackground>
      )}
      <Portal openModal={openModal?.status}>
        {openModal.status && openModal.type === 'infoWorker' && openModal.code && (
          <InfoWorkerModal
            innerTabIndex={0}
            getReportListAPI={getWorkerAPI}
            reportArray={filterTableState}
            setReportArray={setFilterTableState}
            setOpenModal={setOpenModal}
            auth={auth}
            code={{ hCd: userInfo.hCd, sCd: userInfo.sCd, wCd: openModal.code, aDate: today() }}
            index={openModal.index}
            setRowKey={setRowKey}
            listCount={Number(listCount[LIST_COUNT])}
          />
        )}
      </Portal>

      {size.innerSize.W <= 1024 && (
        <Portal openModal>
          <SearchFilterModal openModal={openModal} setOpenModal={setOpenModal} onClickSearch={onClickSearch} onClickReset={onClickInitiateSearchOption}>
            <div className='filter-option-wrapper'>
              <div className='filter-option-col filter-underline filter-option-date'>
                <span className='calendarLabel'>{t('검진일자')}</span>
                <div className='inputForm-col'>
                  <div className='flex-basic' role='presentation' onClick={onClickRangeInput}>
                    <input id='startInput' type='text' readOnly value={searchOption.start} onChange={(e) => onChangeRangeInput(e, 'start', setRangeState, setSearchOption)} />
                    <span className='inputDash'> ~ </span>
                    <input id='endInput' type='text' readOnly value={searchOption.end} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setSearchOption)} />
                  </div>
                  {visibleRangePicker && (
                    <div className='rangePickerWrapper'>
                      <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} />
                    </div>
                  )}
                </div>
              </div>
              <div className='filter-option-cont'>
                <div className='filter-option-row'>
                  <label htmlFor='useYn'>{t('보기 설정')}</label>
                  <SelectBox
                    options={listCountComCdList}
                    defaultOption={listCount.cdName}
                    state={listCount}
                    setState={setListCount}
                    stateKey={LIST_COUNT}
                    initiateKey={listCount[LIST_COUNT]}
                    setTableLinesAPI={patchUserMenuAPI}
                    optionHeight='height-sm'
                    rsearch
                  />
                </div>
                <div className='filter-option-row'>
                  <label htmlFor='wWorkstatus'>{t('근로 상태')}</label>
                  <SelectBox
                    options={WORK_STATUS_SEARCH}
                    defaultOption={t('재직')}
                    state={wWorkstatus}
                    setState={setWWorkstatus}
                    stateKey='wWorkstatus'
                    initiateKey={wWorkstatus.wWorkstatus}
                    filterbar='filter-1-left'
                  />
                </div>
                <div className='filter-option-row'>
                  <label htmlFor='sjCd'>{t('협력업체')}</label>
                  <div className='inputForm-col'>
                    <SearchSelectBoxSm
                      options={siteJoinInfoList}
                      defaultOption={t('전체')}
                      state={sjCd}
                      setState={setSjCd}
                      stateKey='sjCd'
                      codeKey='cdName'
                      initiateKey={sjCd.sjCd}
                      filterbar='filter-1-left'
                      optionHeight='height-md'
                    />
                  </div>
                </div>
                <div className='filter-option-row'>
                  <label htmlFor='wHsresult'>{t('검진 결과')}</label>
                  <div className='inputForm-col'>
                    <SelectBox
                      options={healthSetList}
                      defaultOption={t('검진 결과 전체')}
                      state={wHsresult}
                      setState={setWHsresult}
                      stateKey='wHsresult'
                      initiateKey={wHsresult.wHsresult}
                      filterbar='filter-1-center'
                      optionHeight='height-md'
                    />
                  </div>
                </div>
                {userInfo.prejobtypeYn === 'Y' && (
                  <div className='filter-option-row'>
                    <label htmlFor='sjCd'>{t('공종')}</label>
                    <div className='inputForm-row'>
                      <div className='inputForm-col'>
                        <SearchSelectBoxSm
                          options={prejobtypeList}
                          defaultOption={t('공종 전체')}
                          state={wPrejobtype}
                          setState={setWPrejobtype}
                          stateKey='wPrejobtype'
                          codeKey='cdName'
                          initiateKey={initiate}
                          filterbar='filter-1-right'
                          comboWidth='expand-box-sm'
                          optionHeight='height-md'
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className='filter-option-row'>
                  <label htmlFor='sjCd'>{t('직종')}</label>
                  <SearchSelectBoxSm
                    options={jikJongList}
                    defaultOption={t('직종 전체')}
                    state={wJobtype}
                    setState={setWJobtype}
                    stateKey='wJobtype'
                    codeKey='cdName'
                    initiateKey={wJobtype.wJobtype}
                    filterbar='filter-1-right'
                    comboWidth='expand-box-sm'
                    optionHeight='height-md'
                  />
                </div>
              </div>
            </div>
          </SearchFilterModal>
        </Portal>
      )}
    </div>
  );
};

export default Sworker10;
